import { createContext } from 'react';

export type BrandsPageContextType = {
  onSelectBrandLetter: (event: React.MouseEvent<HTMLDivElement>) => void;
};

const BrandsPageContext = createContext<BrandsPageContextType | undefined>(undefined);

export default BrandsPageContext;
